<template>
  <div class="c-clasp-finish-selector l-flex">
    <div class="c-clasp-finish-selector__container l-flex l-flex--column">
      <h1
        ref="headingToFocus"
        class="c-clasp-finish-selector__title t-heading-5 u-margin-bottom-small"
        tabindex="0"
      >
        {{ step.personalizationTitle }}
      </h1>
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="u-text-align-center u-margin-bottom-medium"
        v-html="step.personalizationDescription"
      />
      <!-- eslint-enable vue/no-v-html -->
      <div class="c-clasp-finish-selector__swatch-container l-flex u-margin-bottom-small">
        <ul
          class="c-clasp-finish-selector__swatch-container__swatch-list l-flex l-flex--justify-space-between"
        >
          <li
            v-for="variant in claspVariants"
            :key="variant.title"
            class="c-clasp-finish-selector__swatch-container__swatch-list__swatch-list-item"
          >
            <btn
              class="c-clasp-finish-selector__swatch-container__swatch-list__swatch-list-item__btn"
              :class="{
                selected: variant.id === selections.clasp.id,
              }"
              :aria-label="variant.id === selections.clasp.id ? variant.title + 'finish currently selected.' : ''"
              :type="variant.id === selections.clasp.id ? 'primary' : 'primary-open'"
              @click="selectClaspFinish(variant)"
            >
              {{ variant.title }}
            </btn>
          </li>
        </ul>
      </div>

      <btn
        :class-modifiers="step.button.fields.type"
        class="c-clasp-finish-selector__next-btn u-margin-bottom-x-small"
        @click="incrementStep"
      >
        {{ step.button.fields.text }} {{ nextStep.fields.personalizationTitle }}
      </btn>

      <btn
        type="link"
        url="#"
        @click="decrementStep"
      >
        BACK
      </btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import Btn from "@/components/button/Btn";

export default {
  name: "ClaspFinishSelector",
  components: {
    Btn
  },
  props: {
    step: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      cta:{
        text: "BACK",
        type: "link"
      },
      selected: undefined,
    }
  },
  computed: {
    ...mapState('braceletBuilder', [
      'bracelets',
      'clasps',
      'selections',
      'currentStep',
      'currentStepIndex'
    ]),
    ...mapGetters('braceletBuilder',[
      'loading',
      'nextStep',
      'claspColor',
      'claspFinish'
    ]),
    claspVariants() {
      let claspColor = this.claspColor;
      let activeClasp = this.clasps.find(function(clasp){
        let color =  clasp.metafields.find(function(meta){
          return meta.key === 'color';
        })
        return JSON.parse(color.value).name === claspColor
      });
      return activeClasp.variants;
    }
  },
  mounted() {
    const headingToFocus = this.$refs.headingToFocus;
    console.log(headingToFocus)
    if (headingToFocus) {
      this.$refs.headingToFocus.focus();
    }
  },
  methods: {
    ...mapMutations('braceletBuilder', [
      'setClasps',
      'setStep',
      'setStepIndex',
      'update'
    ]),
    ...mapActions('braceletBuilder', [
      'incrementStep',
      'decrementStep'
    ]),
    selectClaspFinish(variant) {
      if (variant) {
        return this.update({'clasp': variant});
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .c-clasp-finish-selector {
    max-width: 100vw;
    height: 100%;
    width: 100%;
    .selected {
      @include themify($themes) {
        background-color: themed('foreground', 'selected')
      }
      color: #fff;
    }
    &__container {
      max-width: rem(358px);
    }
    &__swatch {
      margin: 0 rem(2px);
      height: rem(65px);
    }
    &__swatch-container {
      width: 100%;

      &__swatch-list {
        display:flex;
        flex-direction: row;
        justify-content: space-evenly;
        width:100%;

        &__swatch-list-item {
          list-style-type:none;
          width: 100px!important;
          height: auto!important;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all .2s ease-in-out;

          &__btn {
            width: 100px;
            height: 45px;
            text-align:center;
            padding: 0;
            transition: all .2s ease-in-out;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              transform: translateY(3px);
              box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);
            }
          }
        }
      }
    }

    &__next-btn {
      width: 100%;
      max-width: rem(344px);
    }
  }
</style>
